export default function dedupeParagraphs(text) {
  const paragraphs = text
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  if (paragraphs.length <= 1) {
    return text.trim();
  }

  const deduped = [];

  for (const paragraph of paragraphs) {
    if (deduped[deduped.length - 1] !== paragraph) {
      deduped.push(paragraph);
    }
  }

  // Some upstream streams send the completed answer again as a legacy chunk.
  // Collapse adjacent repeated runs such as A,B,C,A,B,C.
  let changed = true;
  while (changed) {
    changed = false;

    for (let runLength = Math.floor(deduped.length / 2); runLength >= 1; runLength -= 1) {
      let collapsed = false;

      for (let start = 0; start + runLength * 2 <= deduped.length; start += 1) {
        const firstRun = deduped.slice(start, start + runLength);
        const secondRun = deduped.slice(start + runLength, start + runLength * 2);

        if (firstRun.every((paragraph, index) => paragraph === secondRun[index])) {
          deduped.splice(start + runLength, runLength);
          changed = true;
          collapsed = true;
          break;
        }
      }

      if (collapsed) {
        break;
      }
    }
  }

  return deduped.join("\n\n");
}
